/**
 * Read a computed custom property from `:root` (for MUI palette, legacy JS config, etc.).
 */
export function readCssVar(name, fallback = '') {
  if (typeof window === 'undefined' || !document?.documentElement) return fallback
  const v = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return v || fallback
}

/**
 * Resolve `var(--token)` for APIs that need concrete colors (Chart.js canvas, etc.).
 * SVG / CSS `style` can use `var(...)` directly; canvas cannot.
 */
export function resolveThemeColor(value) {
  if (typeof value !== 'string') return value
  const trimmed = value.trim()
  const match = /^var\(\s*([^)]+?)\s*\)$/.exec(trimmed)
  if (!match) return value
  const token = match[1].trim()
  if (typeof window === 'undefined') return value
  const resolved = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim()
  return resolved || value
}

export function resolveThemeColors(arr) {
  if (!Array.isArray(arr)) return arr
  return arr.map(resolveThemeColor)
}
